import CustomText from "../atomic/CustomText";
import DetailRenderer from "../global/forms/DetailRenderer";

const AdditionalInformation = ({ order }: any) => (
  <div id="additional info">
    <CustomText
      text={"Additional Information"}
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    <div className="reviewCard">
      {order?.additionalInfo?.map((e: any) => (
        <DetailRenderer
          data={e}
          groupFields={["firstName", "lastName", "npi", "fax", "email"]}
          hiddenFields={[]}
          MainHeading="Additional Information"
          approval={true}
          approvalSectionUrl={`${`/access/online-order/${order.supportingSection.id}#Additional%20Information`}`}
        />
      ))}
    </div>
  </div>
);

export default AdditionalInformation